export type TTextAlign = "center" | "left" | "right" | "justify";

export const buildTextAlignClassName = (align?: TTextAlign) => (align ? `-text-align-${align}` : "");
